export const API_URL = 'https://api.proinstallerai.com/api'
export const CHAT_HISTORY_URL = `${API_URL}/chat/history`
export const ADS_URL = `${API_URL}/ads/get-ads`
export const CHAT_URL = `${API_URL}/chat`
export const FRONTEND_URL = `https://proinstaller.webcase.me`
